export default __webpack_public_path__ + "static/media/cardmaster.ea2cde04.png";